export default __webpack_public_path__ + "static/media/revenue.06587eb2.webp";